import React from 'react';
import { BooleanInput, useGetOne } from 'react-admin';

/**
 * Campaign-form Dynamic Pricing toggle, gated by the advertiser-level
 * dynamic_pricing_enabled flag (false/absent = hidden). UI gating only:
 * hiding the toggle does not clear an already-true campaign value, and the
 * bidstream ETL keys off the campaign field regardless.
 * Caller is responsible for role-gating (see isAdminRole in utils.js).
 */
const AdvertiserDynamicPricingToggle = ({ advertiserId, style }) => {
  const { data } = useGetOne('advertisers', advertiserId);
  if (!data || data.dynamic_pricing_enabled !== true) return null;
  return <BooleanInput source="dynamic_pricing_enabled" label="Dynamic Pricing" style={style} />;
};

export default AdvertiserDynamicPricingToggle;
